const state = {
  mcacShow: false,
};

const mutations = {
  changeAcmcState(state, data) {
    state.mcacShow = data;
  },
};

export default { state, mutations };
